import React from "react";
import { themeFR } from "../../assets/themes/frrmTheme";

const BlockHeader = ({headertext}) => {
    return (
        <h4 style={themeFR.custom.blockHeader}>{headertext}</h4>
    );
};

export default BlockHeader;